module.exports = __webpack_public_path__ + "img/cord.34baf13f.jpg";